/**
 * Auth facts both sides need to agree on. The SERVER is the authority — the UI
 * mirrors these only so it can tell someone their password is too short before
 * making them wait for a round trip.
 */
/** Minimum password length. Enforced server-side in PasswordHasherV2. */
export const MIN_PASSWORD_LENGTH = 10;
//# sourceMappingURL=auth.js.map